var map = {
	"./Arbitrum.svg": 14807,
	"./Base.svg": 58461,
	"./Cronos.svg": 29163,
	"./Ethereum.svg": 36226,
	"./Mantle.svg": 82719,
	"./Optimism.svg": 81014,
	"./Polygon.svg": 23894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26692;